import React from "react";

type BustHeroProps = {
  title: string;
  titleClassName?: string;
  children?: React.ReactNode;
};

// Compact centered page title with the anime bust faded behind on the right.
const BustHero: React.FC<BustHeroProps> = ({ title, titleClassName = "text-3xl font-bold mb-2", children }) => (
  <div className="relative isolate mb-6 overflow-hidden py-4 md:py-5">
    <img
      src="/assets/walt-anime-bust.png"
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -z-10 right-0 -top-4 h-[140px] md:h-[180px] w-auto opacity-25 md:opacity-35"
      style={{
        maskImage: "linear-gradient(to left, black 40%, transparent 95%), linear-gradient(to bottom, black 55%, transparent 100%)",
        maskComposite: "intersect",
        WebkitMaskImage: "linear-gradient(to left, black 40%, transparent 95%), linear-gradient(to bottom, black 55%, transparent 100%)",
        WebkitMaskComposite: "source-in",
      }}
    />
    <div className="mx-auto max-w-2xl text-center">
      <h1 className={titleClassName}>{title}</h1>
      {children}
    </div>
  </div>
);

export default BustHero;
